"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveChecklistToLocalStorage = exports.getChecklistFromLocalStorage = exports.clearChecklistFromLocalStorage = void 0;
var _ravenJs = _interopRequireDefault(require("raven-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getChecklistFromLocalStorage = exports.getChecklistFromLocalStorage = function getChecklistFromLocalStorage(instructionId) {
  var checklist;
  var checklistJSON = localStorage.getItem("checklist_".concat(instructionId));
  try {
    checklist = JSON.parse(checklistJSON);
  } catch (err) {
    _ravenJs["default"].captureException(err);
    localStorage.setItem("checklist_".concat(instructionId), '');
  }
  return checklist || {};
};
var saveChecklistToLocalStorage = exports.saveChecklistToLocalStorage = function saveChecklistToLocalStorage(instructionId, checklist) {
  localStorage.setItem("checklist_".concat(instructionId), JSON.stringify(checklist));
};
var clearChecklistFromLocalStorage = exports.clearChecklistFromLocalStorage = function clearChecklistFromLocalStorage(instructionId) {
  localStorage.removeItem("checklist_".concat(instructionId));
};
//# sourceMappingURL=checklist-utils.js.map